class RequestStashUpdate {
	static protocol = {}

	constructor() {}
}

export default RequestStashUpdate
